"use client";
import dynamic from "next/dynamic";

// Must read process.env directly, not PublicConfig.DEV_ENV: the bundler inlines the
// NEXT_PUBLIC_ literal and drops the dead branch, so in a production build the import
// below — and its whole module graph (dev tools UI, Playwright helpers, Stripe test utils) —
// is never bundled. scripts/check-client-bundle-secrets.mjs asserts this on production builds.
const SpotDevTools = process.env.NEXT_PUBLIC_ENVIRONMENT === "development" ? dynamic(() => import("./index").then(m => m.SpotDevTools), { ssr: true }) : null;

export function DevToolsMount() {
    return SpotDevTools ? <SpotDevTools /> : null;
}
